import { render, staticRenderFns } from "./index-old.vue?vue&type=template&id=068fbba5&scoped=true&"
import script from "./index-old.vue?vue&type=script&lang=js&"
export * from "./index-old.vue?vue&type=script&lang=js&"
import style0 from "./index-old.vue?vue&type=style&index=0&id=068fbba5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068fbba5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VImg,VList,VListItem,VListItemTitle,VMenu})
